import { toast } from "react-hot-toast";

import { TOASTER_ID_KEYS } from "@/constants";
import { authSlice } from "@/store/slices/auth";
import { startAppListening } from "@/store/utils";
import { mapRole } from "@/utils/mapRole";
import { isPayloadErrorWithMessage, isStatusCode401 } from "@/utils/matchers";

import { Role } from "../../_shared";
import { authApi } from "./auth.api";

/**
 * Listener for successful login
 * Updates auth slice with credentials from login response
 */
startAppListening({
  matcher: authApi.endpoints.login.matchFulfilled,
  effect: (action, listenerApi) => {
    const { role: rawRole, auth: __, accessToken, company, ...data } = action.payload;

    if (!accessToken) return listenerApi.cancelActiveListeners();

    const role = mapRole(rawRole);
    const acceptedRoles = [Role.Administrador, Role.Transportadora, Role.Usuario];

    // Convert company.id from string to number if company exists
    const normalizedCompany = company
      ? {
          ...company,
          id: Number(company.id)
        }
      : undefined;

    const payload = {
      ...data,
      role,
      token: accessToken,
      company: normalizedCompany
    } as Parameters<typeof authSlice.actions.setCredentials>[0];

    if (!acceptedRoles.includes(role)) {
      toast.error("Você não tem permissão para acessar o admin!");

      listenerApi.dispatch(authSlice.actions.logout());
      listenerApi.cancelActiveListeners();

      return;
    }

    if (import.meta.env.DEV) console.log("Login successful, updating auth state:", { role, payload });
    listenerApi.dispatch(authSlice.actions.setCredentials(payload));
  }
});

/**
 * Listener for failed login
 * Displays error message from login response or a generic error if message is not available
 */
startAppListening({
  matcher: authApi.endpoints.login.matchRejected,
  effect: ({ payload }) => {
    if (isStatusCode401(payload) && isPayloadErrorWithMessage(payload)) {
      toast.error(payload.error.data.message, { position: "top-right" });
    }
  }
});

/**
 * Listener for logout
 * Resets API state and clears all toasts
 */
startAppListening({
  matcher: authSlice.actions.logout.match,
  effect: async (_action, listenerApi) => {
    if (import.meta.env.DEV) console.log("Logout triggered, resetting API state");
    listenerApi.cancelActiveListeners();

    // listenerApi.dispatch(nextCargoApi.util.resetApiState());
    toast.remove(TOASTER_ID_KEYS.AUTH.LOGIN_REDIRECT);
    toast.remove(TOASTER_ID_KEYS.AUTH.LOGIN_SUCCESS);
  }
});

// startAppListening({
//   matcher: authApi.endpoints.login.matchPending,
//   effect: async (action, listenerApi) => {
//     const cookies = Cookies.get("userTerm");
//     const acceptedTerms = cookies === "accepted";
//     if (await listenerApi.condition(() => !acceptedTerms)) {
//       listenerApi.cancelActiveListeners();
//       toast.remove(TOASTER_ID_KEYS.AUTH.LOGIN);
//       toast.remove(TOASTER_ID_KEYS.AUTH.NOT_ALLOWED);
//       console.log("No cookies found, logging out");
//       toast.error("Você precisa aceitar os termos de uso para continuar!");
//       listenerApi.dispatch(authSlice.actions.logout());
//       MODAL_HANDLER.acceptTerms();
//     }
//   }
// });
